import { useTheme } from '@hermes/web-components';

const resolveThemeComponent = (components) => {
    const theme = useTheme();
    const themeName = theme.name;
    return components[themeName];
};

export { resolveThemeComponent as default };
